export default {
  methods: {
    $_validation_validate() {
      return new Promise((resolve, reject) => {
        if (!('form' in this.$refs)) {
          resolve();
          return;
        }

        this.$refs.form.validate()
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
};
